import React, { useState, useEffect } from "react";
import {
    Drawer,
    Button,
    Form,
    Input,
    Row,
    Col,
    notification,
    Space,
    Typography,
    Flex,
    Select,
    TreeSelect,
    Dropdown
} from "antd";
import {
    DeleteOutlined,
    QuestionCircleOutlined,
    DownOutlined,
    ShrinkOutlined,
    ExpandOutlined
} from "@ant-design/icons";
import UploadButton from "../../common/UploadButton";
import globalData from "../../../config/global_data";
import ErrorNotification from "../../common/ErrorNotification";
import StatusBadge from "../../common/StatusBadge";
import common_api from "../../../config/common_api";
import CommonAttributeList from "../../common/CommonAttributeList";
import { triggerNotification } from "../../common/notify";
import CreateAttributeList from "../../common/CreateAttributeList";
import ProductList from "../ProductList";



const { Text } = Typography;

const ButtonItems = [
    {
        label: 'Save as Draft',
        key: 'saveDraft',
    },
    {
        label: 'Save & Reload',
        key: 'saveReload',
    },
];

const CreateBundle = ({ visible, onClose, selected_prod_data, setisloader, globalList , setGlobalList}) => {
    const [form] = Form.useForm();
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedSku, setSelectedSku] = useState(null);
    const [bundleTitle, setBundleTitle] = useState("New Bundle Product");
    const [treeData, setTreeData] = useState(null)
    const [stores, setStoreOptions] = useState([]);
    const [selectedStores, setSelectedStores] = useState([]);
    const [currencySymbol, setCurrencySymbol] = useState("");
    const [SAPSKU_options, setOptions] = useState(null);
    const [selectedValues, setSelectedValues] = React.useState([]);
    const [savedimages, setSavedimgaes] = useState(null);
    const [imageObj, setImageObj] = useState(null);
    const [savedattributes, setSavedattributes] = useState(null);
    const [innerProducts, setInnerProducts] = useState(null);
    const [selectedStoreID, setSelectedStoreID] = useState(null);
    const [data, setData] = useState({})
    const [disabledProd_id, setDisabledProd_id] = useState("")


    useEffect(() => {


        if (globalData.store_list && globalData.store_list.length > 0) {
            let final_storelist = globalData.store_list.filter(val => val.value != "all")

            setStoreOptions(final_storelist);
        }
        if (selected_prod_data && visible) {
            if (selected_prod_data.bundle_sap_Array) {
                let Xprod_id = selected_prod_data.bundle_sap_Array.filter(item => item.prod_id == 0)
                if (Xprod_id && Xprod_id.length > 0) {
                    const mappedResult = Xprod_id.map(item => item.sku);
                    const mergedString = mappedResult.join(" , ");                 
                    
                    setDisabledProd_id(mergedString)
                }
            }
            let main_prod_name = selected_prod_data.bc_name ? selected_prod_data.bc_name : selected_prod_data.sapName
            setData(selected_prod_data);
            setBundleTitle(main_prod_name || "New Simple Product");
            setSelectedStores(selected_prod_data.store);

            const store_id_data = globalData.store_list?.filter(
                (item) => item.value === selected_prod_data.store
            );

            if (store_id_data?.[0]) {
                if (globalData.sap_sku_list?.length > 0) {
                    const sapsku = globalData.sap_sku_list.filter(
                        (item) =>
                            item.store_id === store_id_data[0].store_id &&
                            item.prod_count < 1 &&
                            item.variant_count < 1
                    );
                    setOptions(sapsku);
                }

                if (globalData.all_cat_list?.length > 0) {
                    const cattree = globalData.all_cat_list.filter(
                        (item) => item.store_id === store_id_data[0].store_id
                    );
                    if (cattree?.[0]?.treedata) {
                        setTreeData(cattree[0].treedata);
                    }
                }
            }

            form.setFieldsValue({
                msrpPrice: selected_prod_data.sapMsrp.replace(selected_prod_data.currency_symbol, ""),
                salePrice: selected_prod_data.sapPrice.replace(selected_prod_data.currency_symbol, ""),
                SAPmsrp: selected_prod_data.sapMsrp,
                SAPPrice: selected_prod_data.sapPrice,
                pname: selected_prod_data.bc_name || selected_prod_data.sapName,
                sap_sku_select: selected_prod_data.sapSku,
                store: selected_prod_data.store,
            });
        }
    }, [globalData, selected_prod_data]);

    const SAPSKU_options_handleChange = (value) => {
        setSelectedSku(value);
    };
    const onChange = (values) => {
        setSelectedValues(values);
    };
    const openNotification = () => {
        triggerNotification({
            type: 'error',
            title: 'Form incomplete!',
            message: "Please fix all errors before saving.",
        });
    };
    const handleMenuClick = ({ key }) => {
        form
            .validateFields()
            .then((values) => {
                if (key === 'save') {
                    onClose(); // Replace with your actual save logic
                }
            })
            .catch(() => {
                openNotification();
            });
    };
    const handleBlur = () => {
        const bundleName = form.getFieldValue("pname");
        if (bundleName && bundleName.trim()) {
            setBundleTitle(bundleName);
        } else {
            setBundleTitle("New Product");
        }
    };
    const store_options_handleChange = async (value) => {
        let store_id_data = await globalData.store_list.filter(item => item.value === value)
        if (globalData.all_cat_list && globalData.all_cat_list.length > 0) {
            let cattree = await globalData.all_cat_list.filter(item => item.store_id === store_id_data[0].store_id)
            setCurrencySymbol(store_id_data[0]?.currency_symbol || "$");
            if (cattree && cattree.length > 0) {
                setTreeData(cattree[0].treedata)
            }
        }
        if (globalData.sap_sku_list && globalData.sap_sku_list.length > 0) {
            let sapsku = await globalData.sap_sku_list.filter(item => item.store_id === store_id_data[0].store_id && item.prod_count < 1 && item.variant_count < 1)
            setOptions(sapsku);
        }
        setSelectedStoreID(store_id_data[0].store_id)
        setSelectedStores(value);
    };
    const handleInputChange = (name) => (e) => {
        const value = e.target.value.replace(/[^\d]/g, '');
        form.setFieldsValue({ [name]: value });
    };
    const handleSaveAndPublish = async (values) => {

        if (disabledProd_id != "") {
            triggerNotification({
                type: 'error',
                title: 'Mapping incomplete!',
                message: `Some bundle components are missing from the store: ${disabledProd_id}. please check their mapping in the store.`,
            });
            return 1
        }
        let images = [], remove_from_GCP = []
        if (savedimages.image_data && savedimages.image_data.length > 0) {
            images = await savedimages.image_data.map(item => {
                if (item.thumbUrl && item.thumbUrl.startsWith('https://storage.googleapis.com/')) {
                    remove_from_GCP.push(item.thumbUrl)
                }
                if (item.is_saved) {
                    return {
                        id: item.is_saved,
                        url_standard: item.thumbUrl
                    }
                } else {
                    return {
                        image_url: item.thumbUrl
                    }
                }
            })
        }
        let custom_fields_final = [];
        if (savedattributes.custom_fields && savedattributes.custom_fields.length > 0) {
            const data = savedattributes.custom_fields;
            await data.forEach(attr => {
                const { pattern, values, attribute_key, max_size } = attr;
                let baseKey = attribute_key
                let counter = 1;

                values.forEach((item, index) => {
                    if (item) {
                        let itemobj = {}
                        if (baseKey.includes("NUM")) {
                            itemobj = {
                                "name": baseKey.replace("NUM", counter),
                                "value": item
                            }
                        } else if (max_size === 1) {
                            itemobj = {
                                "name": baseKey,
                                "value": item
                            }
                        }
                        else {
                            itemobj = {
                                "name": baseKey + "_" + counter,
                                "value": item
                            }
                        }
                        custom_fields_final.push(itemobj)
                        counter++;
                    }
                });
            });

        }
        let req_data = {
            "store": selectedStores,
            "data": {
                "name": values.pname,
                "sku": data.sapSku,
                "price": values.msrpPrice.replace(data.currency_symbol, ""),
                "sale_price": values.salePrice.replace(data.currency_symbol, ""),
                "images": images && images.length > 0 ? images : [],
                "custom_fields": custom_fields_final,
                "categories": selectedValues,
                "type": "physical",
                "weight": 0
            },
            innerProducts: { innerProducts, modifier_data: null },
            is_bundle_product: 1
        }
        setisloader(true)
        let responsedata = await common_api.create_simple_product(req_data)
        if (responsedata) {
              let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata, true)
              if (alldata) {
                await setGlobalList(alldata)
              }
            triggerNotification(responsedata)
        }
        setisloader(false)
        onClose()
    }
    const handleSaveAndPublishClick = () => {
        form
            .validateFields()
            .then((values) => {
                handleSaveAndPublish(values);
            })
            .catch(() => {
                openNotification();
            });
    };
    return (
        <Drawer className={`DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
            title={bundleTitle}
            width={isExpanded ? 'calc(100% - 256px)' : 600}
            onClose={onClose}
            open={visible}
            extra={
                <>
                    <div className="DrawerButtonBox">
                        <Button
                            className="ExpandDrawer"
                            onClick={() => setIsExpanded(!isExpanded)}
                            style={{ marginRight: 8 }}
                        >
                            {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
                        </Button>

                        <ErrorNotification {...alert} />

                        <Dropdown.Button
                            type="primary"
                            icon={<DownOutlined />}
                            menu={{
                                items: ButtonItems,
                                onClick: handleMenuClick,

                            }}
                            trigger={['click']}
                            onClick={handleSaveAndPublishClick}
                            style={{ marginLeft: 8 }}

                        >
                            Save & Publish
                        </Dropdown.Button>
                    </div>
                </>
            }
        >
            <Form layout="vertical" form={form}>
                <div className={`FlexItemBox ${isExpanded ? "ExpandedFlexName" : ""}`}>
                    <Form.Item
                        className="ExpandedFlexProductName"
                        name="pname"
                        rules={[{ required: true, whitespace: true, message: "Please enter Product name" }]}
                        label={
                            <span>
                                Product Name&nbsp;
                            </span>
                        }
                    >
                        <Input placeholder="Enter a Product Name" onChange={handleBlur} value={bundleTitle} maxLength={150}/>
                    </Form.Item>
                    <Flex className="flexbox">
                        <Form.Item label={
                            <span>
                                Store&nbsp;
                            </span>} name="store" className="" style={{ width: "200px" }}
                            rules={[{ required: true, message: "Please Select a Store" }]}>
                            <Select
                                showSearch
                                style={{ width: "100%" }}
                                placeholder="Select Store"
                                options={stores}
                                onChange={store_options_handleChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label={
                                <span>
                                    SAP SKU&nbsp;
                                </span>
                            }
                            className="sap_sku_select"
                        >
                            <Input placeholder="SAP SKU" value={data.sapSku} disabled />
                        </Form.Item>
                    </Flex>
                </div>
                <Form.Item
                    label={
                        <span>
                            Product Categories&nbsp;                           
                        </span>
                    }

                    rules={[{ required: true, message: "Please select at least one category" }]}
                >
                    <TreeSelect
                        className="CategoryTree"
                        multiple
                        treeData={treeData}
                        value={selectedValues}
                        onChange={onChange}
                        placeholder="Please select"
                        showSearch
                        treeDefaultExpandAll
                        treeNodeFilterProp="title"
                    />
                </Form.Item>
                <div className={`FlexItemBox ${isExpanded ? "ExpandedFlexRow" : ""}`}>
                    <Row gutter={8} className="ExpandedFlexRowInner">
                        <Col span={12}>
                            <Form.Item
                                label={
                                    <span>
                                        Store MSRP&nbsp;
                                    </span>
                                }
                                name="msrpPrice"
                                rules={[
                                    { required: true, message: "Please enter the Store MSRP" },
                                ]}
                            >
                                <Input
                                    placeholder="Enter MSRP"
                                    prefix={""}
                                    onChange={handleInputChange("msrpPrice")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={
                                    <span>
                                        Store Sale Price&nbsp;
                                    </span>
                                }
                                name="salePrice"
                                rules={[
                                    { required: true, message: "Please enter the sale price" },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const msrp = parseFloat(getFieldValue('msrpPrice'));
                                            const sale = parseFloat(value);
                                            if (!value || isNaN(msrp) || isNaN(sale) || sale <= msrp) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Sale Price cannot be greater than MSRP');
                                        },
                                    }),
                                ]}
                            >
                                <Input placeholder="Enter Sale Price" prefix={""}
                                    onChange={handleInputChange("salePrice")} />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                {visible && <Form.Item
                    label={
                        <span>
                            PDP Gallery&nbsp;
                        </span>
                    }
                >
                    <UploadButton
                        setSavedimgaes={setSavedimgaes}
                        product_obj={imageObj}
                        MAX_UPLOADS="50"
                        delete="true"
                        replace="true"
                        thumbnail="true"
                        hover=""
                    />
                </Form.Item>}
                <div className="ProductDetailBox">
                    <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes" : ""}`}>
                        {visible && <CreateAttributeList setSavedattributes={setSavedattributes} />}
                        {visible && <ProductList bundle_products={selected_prod_data} store_id={selectedStoreID} setInnerProducts={setInnerProducts} form={form} />}
                    </div>
                </div>
            </Form>

        </Drawer>
    )

}
export default CreateBundle;